import IPreferences from '../../models/IPreferences';

export const initialState: IPreferences= {
    language:'en',
    isLanguageChanged: false
};
